import { actionTypes } from './constants';
import * as Types from './types';
import { IParsedMyAccountSidebarMenuItem } from '../types';

export const updateSidebarData = ({
    headerWcId,
    footerWcId,
    menuItems
}: {
    headerWcId: string;
    footerWcId: string;
    menuItems: IParsedMyAccountSidebarMenuItem[];
}): Types.IUpdateSidebarDataAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_DATA_UPDATE,
    payload: { headerWcId, footerWcId, menuItems }
});

export const toggleSidebar = (): Types.IToggleSidebarAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_TOGGLE
});

export const openSidebar = (): Types.IOpenSidebarAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_OPEN
});

export const closeSidebar = (): Types.ICloseSidebarAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_CLOSE
});

export const showMainMenu = (): Types.IShowMainMenuAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_MENU_ITEMS_MAIN_MENU_SHOW,
    isSilent: true
});

export const changeMenuHeight = (height: string): Types.IChangeMenuHeightAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_MENU_HEIGHT_CHANGE,
    payload: height,
    isSilent: true
});

export const showSubMenu = (nextMenuItems: IParsedMyAccountSidebarMenuItem[]): Types.IShowSubMenuAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_MENU_ITEMS_SUB_MENU_SHOW,
    payload: nextMenuItems,
    isSilent: true
});

export const showPortalPage = (
    { pageURL, isBackArrowHidden }: { pageURL: string; isBackArrowHidden: boolean }
): Types.IShowPortalPageAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_PORTAL_PAGE_SHOW,
    payload: { pageURL, isBackArrowHidden }
});

export const changeName = (name: string): Types.IChangeNameAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_NAME_CHANGE,
    payload: name,
    isSilent: true
});

export const showHomePage = (): Types.IShowHomePageAction => ({
    type: actionTypes.MY_ACCOUNT_SIDEBAR_HOME_PAGE_SHOW,
    isSilent: true
});
